// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3whA3","inputWrap":"Table_inputWrap__3Pbif","col":"Table_col__1lgNa","bmiTooltip":"Table_bmiTooltip__1ywBb"};